import { Component } from '.';
import { TransformPosition, BoxDimensions } from '../../interfaces';

/**
 * Interactor component.
 */
export class Interactor extends Component {
	public state: { mesh?: string | BoxDimensions } = {};
	public onPointerEnter = new Set<(pos: TransformPosition) => void>();
	public onPointerLeave = new Set<(pos: TransformPosition) => void>();
}
